// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GhGC","textarea":"styles_textarea__2PkTm"};